import PropTypes from "prop-types";
import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { ORDER } from "constants/routes";
import {
  Container,
  StyledTitle,
  // StyledAddCircleIcon,
  Icons,
  StyledButton,
} from "styles/components/page-title";
import CreateOrderModal from "components/CreateOrderModal";

const PageTitle = ({ title, createOrder, buttons, onCreate }) => {
  // const navigate = useNavigate();
  const [isCreateOrderModalOpen, setIsCreateOrderModalOpen] = useState(false);

  const handleCreateOrderClick = () => {
    setIsCreateOrderModalOpen(true);
  };

  const handleCreateOrderModalClose = () => {
    setIsCreateOrderModalOpen(false);
  };

  return (
    <Container>
      <StyledTitle variant="h5">{title}</StyledTitle>

      <Icons>
        {/* {createOrder && <StyledAddCircleIcon onClick={() => navigate(ORDER)} />} */}

        {createOrder && (
          <StyledButton
            label="Create Order"
            variant="contained"
            onClick={handleCreateOrderClick}
          />
        )}

        {buttons?.map((b) => {
          const label = b?.label;
          return (
            <StyledButton
              key={label}
              label={label}
              variant="contained"
              onClick={b?.onClick}
            />
          );
        })}
      </Icons>

      <CreateOrderModal
        open={isCreateOrderModalOpen}
        onClose={handleCreateOrderModalClose}
        onCreate={onCreate}
      />
    </Container>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string,
  createOrder: PropTypes.bool,
  onCreate: PropTypes.func,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
};

PageTitle.defaultProps = {
  title: "",
  createOrder: false,
  buttons: undefined,
  onCreate: () => {},
};

export default PageTitle;
